<app-nav titulo="Nueva garantía" descripcion="Por favor complete todos los datos para crear la garantía.">
    <div class="new-warranty" *ngIf="quote">
        <div class="section tenants-section">
            <span class="section-title">
                Datos de los inquilinos
            </span>
            <div class="section-box">
                <form class="tenant" *ngFor="let tenantFG of tenantsControls; let i = index" [formGroup]="tenantFG">
                    <div class="tenant-title-container">
                        <span class="subsection-title"> Inquilino número {{ i + 1 }} </span>
                        <button mat-icon-button matTooltip="Eliminar inquilino" class="delete-tenant" color="accent"
                            *ngIf="i !== 0" (click)="tenantsFormArray.removeAt(i)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                    <mat-radio-group class="form-radio-line" formControlName="tipoPersona" color="primary">
                        <span class="radio-line-label">
                            Tipo de persona
                        </span>
                        <div class="radios">
                            <mat-radio-button value="FISICA">Persona física</mat-radio-button>
                            <mat-radio-button value="JURIDICA">Persona jurídica</mat-radio-button>
                        </div>
                    </mat-radio-group>
                    <div *ngIf="tenantFG.controls.tipoPersona.value === 'FISICA'">
                        <!-- PRIMERA LÍNEA: DNI/Pasaporte, Nombre, Apellido -->
                        <div class="line">
                            <div class="document-field-container">
                                <mat-form-field class="garantor-form-field document-type-select" appearance="outline">
                                    <mat-label>Tipo</mat-label>
                                    <mat-select formControlName="tipoDocumento">
                                        <mat-option value="DNI">DNI</mat-option>
                                        <mat-option value="PASAPORTE">Pasaporte</mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field class="garantor-form-field dni-pasaporte-field" appearance="outline"
                                    *ngIf="tenantFG.controls.tipoDocumento.value === 'DNI'">
                                    <mat-label>DNI</mat-label>
                                    <input matInput formControlName="dni">
                                    <mat-error *ngIf="tenantFG.controls.dni.hasError('required')">
                                        Por favor ingrese un dni
                                    </mat-error>
                                    <mat-error
                                        *ngIf="tenantFG.controls.dni.hasError('minlength') || tenantFG.controls.dni.hasError('maxlength')">
                                        El dni debe tener 8 dígitos
                                    </mat-error>
                                    <mat-error *ngIf="tenantFG.controls.dni.hasError('number')">
                                        El dni debe ser un número
                                    </mat-error>
                                    <mat-hint>Ejemplo: 12345678</mat-hint>
                                </mat-form-field>

                                <mat-form-field class="garantor-form-field dni-pasaporte-field" appearance="outline"
                                    *ngIf="tenantFG.controls.tipoDocumento.value === 'PASAPORTE'">
                                    <mat-label>Pasaporte</mat-label>
                                    <input matInput formControlName="pasaporte">
                                    <mat-error *ngIf="tenantFG.controls.pasaporte.hasError('required')">
                                        Por favor ingrese un pasaporte
                                    </mat-error>
                                    <mat-hint>Ejemplo: ABC123456</mat-hint>
                                </mat-form-field>
                            </div>

                            <mat-form-field class="garantor-form-field nombre" appearance="outline">
                                <mat-label>Nombre</mat-label>
                                <input matInput formControlName="nombre">
                                <mat-error *ngIf="tenantFG.controls.nombre.hasError('required')">
                                    Por favor ingrese un nombre
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field class="garantor-form-field apellido" appearance="outline">
                                <mat-label>Apellido</mat-label>
                                <input matInput formControlName="apellido">
                                <mat-error *ngIf="tenantFG.controls.apellido.hasError('required')">
                                    Por favor ingrese un apellido
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <!-- SEGUNDA LÍNEA: Teléfono, Email, Sexo -->
                        <div class="line">
                            <mat-form-field class="garantor-form-field celular" appearance="outline">
                                <mat-label>Teléfono *</mat-label>
                                <app-phone-input formControlName="celular"></app-phone-input>
                                <mat-error *ngIf="tenantFG.controls.celular.hasError('required')">
                                    Por favor ingrese un teléfono
                                </mat-error>
                                <mat-hint>Ejemplo: + 54 - 911 - 11112222</mat-hint>
                            </mat-form-field>

                            <mat-form-field class="garantor-form-field email" appearance="outline">
                                <mat-label>Email</mat-label>
                                <input matInput formControlName="email">
                                <mat-error *ngIf="tenantFG.controls.email.hasError('email')">
                                    Email inválido
                                </mat-error>
                            </mat-form-field>

                            <app-sex-selector class="sex-selector-container" formControlName="sexo"
                                [vertical]="true"></app-sex-selector>
                        </div>
                    </div>
                    <div class="line" *ngIf="tenantFG.controls.tipoPersona.value === 'JURIDICA'">
                        <mat-form-field class="garantor-form-field cuit" appearance="outline">
                            <mat-label>CUIT</mat-label>
                            <app-cuit-input formControlName="cuit"></app-cuit-input>
                            <mat-error *ngIf="tenantFG.controls.cuit.hasError('required')">
                                Por favor ingrese un cuit
                            </mat-error>
                            <mat-error
                                *ngIf="tenantFG.controls.cuit.hasError('minlength') || tenantFG.controls.cuit.hasError('maxlength')">
                                El cuit debe tener 11 dígitos
                            </mat-error>
                            <mat-error *ngIf="tenantFG.controls.cuit.hasError('number')">
                                El cuit debe ser un número
                            </mat-error>
                            <mat-hint>Sin guiones, ejemplo: 20123456781</mat-hint>
                        </mat-form-field>
                        <mat-form-field class="garantor-form-field razon-social" appearance="outline">
                            <mat-label>Razón social</mat-label>
                            <input matInput formControlName="razonSocial">
                            <mat-error *ngIf="tenantFG.controls.razonSocial.hasError('required')">
                                Por favor ingrese una razón social
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="garantor-form-field celular" appearance="outline">
                            <mat-label>Teléfono</mat-label>
                            <app-phone-input formControlName="celular"></app-phone-input>
                            <mat-error *ngIf="tenantFG.controls.celular.hasError('required')">
                                Por favor ingrese un teléfono
                            </mat-error>
                            <mat-hint>Ejemplo: + 54 - 911 - 11112222</mat-hint>
                        </mat-form-field>
                    </div>
                </form>
                <div class="add-tenant" (click)="addTenant()"
                    *ngIf="tenantsControls[0].controls.tipoPersona.value === 'FISICA'">
                    <mat-icon>add_circle</mat-icon>
                    Agregar inquilino
                </div>
            </div>
        </div>
        <div class="section quotation-section">
            <span class="section-title">
                Datos de la cotización
            </span>
            <div class="section-box quote-details">
                <app-data-printer-v2
                    [categories]="generateQuotationCategories(quote, utilsService)"></app-data-printer-v2>
            </div>
        </div>
        <div class="section owners-section">
            <span class="section-title">
                Datos de los propietarios
            </span>
            <div class="section-box no-property" *ngIf="!quote.propiedad">
                No se ha seleccionado una propiedad
            </div>
            <div class="section-box no-owner" *ngIf="quote.propiedad && !quote.propiedad?.propietarios?.length">
                No hay propietarios asociados a la propiedad
            </div>
            <div class="section-box owner-details" *ngIf="quote.propiedad?.propietarios?.length">
                <div class="owner" *ngFor="let owner of quote.propiedad.propietarios; let i = index">
                    <span class="subsection-title"> Propietario número {{ i + 1 }} </span>
                    <app-data-printer-v2 [categories]="generateOwnerCategories(owner)"></app-data-printer-v2>
                    <div class="edit-owner-row">
                        <a [routerLink]="'/propietarios/' + owner.id + '/editar'" target="_blank">
                            <button mat-raised-button color="primary" type="button"
                                class="garantor-button mini edit-owner-button">
                                Modificar propietario
                            </button>
                        </a>
                        <button mat-icon-button type="button" class="refresh-button" color="primary"
                            (click)="getQuote(quote.id)">
                            <mat-icon>refresh</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="section property-section">
            <span class="section-title">
                Datos de la propiedad
            </span>
            <div class="section-box no-property" *ngIf="!quote.propiedad">
                No se ha seleccionado una propiedad
            </div>
            <div class="section-box property-details" *ngIf="quote.propiedad">
                <app-data-printer-v2 [categories]="generatePropertyCategories(quote.propiedad)"></app-data-printer-v2>
                <div class="edit-property-row">
                    <a [routerLink]="'/propiedades/' + quote.propiedad.id + '/editar'" target="_blank">
                        <button mat-raised-button color="primary" type="button"
                            class="garantor-button mini edit-property-button">
                            Modificar propiedad
                        </button>
                    </a>
                    <button mat-icon-button type="button" class="refresh-button" color="primary"
                        (click)="getQuote(quote.id)">
                        <mat-icon>refresh</mat-icon>
                    </button>
                </div>
            </div>
        </div>
        <button mat-raised-button color="accent" type="button" class="garantor-button start-warranty-button"
            (click)="createWarranty()">
            Comenzar garantía
        </button>
    </div>
</app-nav>